import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addSubscriptionPlan } from '../redux/slices/subscriptionPlanSlice';
import '../styles/FormStyles.css';

const SubscriptionPlanForm = () => {
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.subscriptionPlans);
  const [formData, setFormData] = useState({
    name: '',
    price: '',
    durationMonths: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name || !formData.price || !formData.durationMonths) {
      alert('Please fill in all fields');
      return;
    }
    dispatch(addSubscriptionPlan({
      name: formData.name,
      price: parseFloat(formData.price),
      durationMonths: parseInt(formData.durationMonths),
    }));
    setFormData({
      name: '',
      price: '',
      durationMonths: '',
    });
  };

  return (
    <div className="form-container">
      <h3>Add New Subscription Plan</h3>
      <form onSubmit={handleSubmit} className="modern-form">
        <div className="form-group">
          <label htmlFor="name">Plan Name</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter plan name"
            disabled={loading}
          />
        </div>

        <div className="form-group">
          <label htmlFor="price">Price (₹)</label>
          <input
            type="number"
            id="price"
            name="price"
            value={formData.price}
            onChange={handleChange}
            placeholder="Enter price"
            step="0.01"
            disabled={loading}
          />
        </div>

        <div className="form-group">
          <label htmlFor="durationMonths">Duration (Months)</label>
          <input
            type="number"
            id="durationMonths"
            name="durationMonths"
            value={formData.durationMonths}
            onChange={handleChange}
            placeholder="Enter duration in months"
            disabled={loading}
          />
        </div>

        {error && <div className="error-message">{error}</div>}

        <button type="submit" className="submit-btn" disabled={loading}>
          {loading ? 'Adding...' : 'Add Plan'}
        </button>
      </form>
    </div>
  );
};

export default SubscriptionPlanForm;
